function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

function SvgAmd(props) {
  const light = props.light || '#999';
  const dark = props.dark || '#000';
  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 74 74",
    xmlns: "http://www.w3.org/2000/svg",
    "uc-svg": "www"
  }, props), React.createElement("g", {
    fill: dark,
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M71.474 42.154a15.54 15.54 0 01-1.04-.87 10.01 10.01 0 01-.831-.862 9.002 9.002 0 01-.935.889c-.35.29-.754.59-1.212.898l-.73-.882-.232.463-.742-.397v.563H64.59V38.15h-.775c-.014.339-.035.653-.06.943-.027.29-.058.558-.095.8a6.06 6.06 0 01-.276 1.153 8.864 8.864 0 01-.498 1.13l-1.085-.53a6.373 6.373 0 00.753-2.161c.051-.36.09-.803.116-1.33.026-.525.039-1.145.039-1.858v-4.248h1.14v2.726h.774V31.85h1.14v2.924h.642v1.147h-2.557v1.037h1.904v3.784c.162-.347.3-.694.415-1.043.115-.35.2-.682.26-.998.14-.765.21-1.765.21-3.001v-3.078c.783-.044 1.602-.13 2.458-.26a34.211 34.211 0 002.456-.457l.221 1.225c-.31.074-.632.141-.968.204a41.53 41.53 0 01-1.057.182c-.73.11-1.395.198-1.992.264v1.016h3.929v1.169c-.318 1.42-.778 2.603-1.383 3.552l-.012.01c.494.56 1.133 1.09 1.915 1.59l-.73 1.036zm1.564-12.09H60.967a.954.954 0 00-.952.95v12.032c0 .523.428.95.952.95h12.07a.954.954 0 00.954-.95V31.015a.955.955 0 00-.953-.95z"
  }), React.createElement("path", {
    d: "M67.894 37c-.021.956-.103 1.745-.245 2.367A6.437 6.437 0 0167 41c.426-.223.803-.45 1.133-.68.33-.23.618-.463.867-.699a5.788 5.788 0 01-.628-1.157A10.585 10.585 0 0167.894 37M69 36c.058.391.127.756.208 1.095.08.339.168.64.264.905a7.68 7.68 0 00.307-.918c.09-.33.163-.691.221-1.082h-1zM6.803 33.822L4.98 38.425h3.787l-1.964-4.603zm7.196 9H10.68l-1.01-2.34H4.166l-.92 2.34H0l4.958-11.814h3.554l5.487 11.815zM25.377 31H28v12h-3.012v-7.48l-3.258 3.765h-.46l-3.258-3.781v7.48H15V31h2.622l3.878 4.463zM33.005 40.802h1.962c3.022 0 3.924-2.04 3.924-3.802 0-2.078-1.115-3.802-3.957-3.802h-1.929v7.604zM35.322 31c4.4 0 6.678 2.725 6.678 6.017C42 40.466 39.809 43 35 43h-5V31h5.322zM53.427 33.572H47.57L44 30h13v13l-3.573-3.572zM47.166 39.831V34L43 38.164V44h5.834L53 39.831z"
  })));
}

SvgAmd.clsName = 'icon-www__AMD';
SvgAmd.remarkName = 'unknown';
export default SvgAmd;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ucloud-icons/dist/www/svgr/Amd.js
// module id = 2273
// module chunks = 17 18